const ROUTE_TITLES = [
  ["/doctor/patients/", "Fiche patient"],
  ["/nurse/patients/", "Fiche patient"],
  ["/doctor/dashboard", "Tableau de bord"],
  ["/doctor/patients", "Patients"],
  ["/doctor/messages", "Messages"],
  ["/doctor/appointments", "Rendez-vous"],
  ["/nurse/dashboard", "Tableau de bord"],
  ["/nurse/workqueue", "Relève IDE"],
  ["/nurse/patients", "Patients"],
  ["/nurse/messages", "Messages"],
  ["/nurse/appointments", "Rendez-vous"],
  ["/nurse/education", "Éducation thérapeutique"],
  ["/secretary", "Secrétariat médical"],
  ["/admin/clinic", "Administration clinique"],
  ["/admin/group", "Administration groupe"],
  ["/admin/super", "Super admin SaaS"],
  ["/admin/appointments-validation", "Validation des rendez-vous"],
  ["/superadmin/analytics", "Analytics & cohortes"],
  ["/superadmin/communication", "Communications"],
  ["/profile", "Mon profil"],
  ["/legal", "Documents juridiques"],
];

export function titleForPath(pathname) {
  const hit = ROUTE_TITLES.find(([prefix]) => pathname.startsWith(prefix));
  return hit ? hit[1] : "";
}
